export default "__VITE_ASSET__DJ33fW3m__"